import { Component, inject, input, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {
  ButtonExpand,
  ButtonComponent,
  ButtonSize,
  InfoModalVariant,
  NotificationVariant,
  Size,
} from '@circlek-global/lds-components';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ApiService } from '../api/api.service';
import { AuthService } from '../auth/auth.service';
import { LoaderService } from '../components/loader/loader.service';
import { ModalBaseComponent } from '../components/modal-base/modal-base.component';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-user-profile',
  imports: [ButtonComponent, TranslateModule, ReactiveFormsModule, ModalBaseComponent],
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent {
  @ViewChild(ModalBaseComponent) modalBaseComponent!: ModalBaseComponent;
  private readonly apiService = inject(ApiService);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly loaderService = inject(LoaderService);
  readonly InfoModalVariant = InfoModalVariant;
  readonly editDataButtonSize = input<ButtonSize>(Size.XL);
  readonly editDataButtonExpand = input<ButtonExpand>(ButtonExpand.FULL);
  readonly notificationSuccessVariant = input<NotificationVariant>(NotificationVariant.SUCCESS);
  protected readonly user = this.userService.userData.asReadonly();
  protected readonly error = this.userService.userError.asReadonly();
  protected readonly isLoading = this.loaderService.isLoading.asReadonly();
  protected readonly region = this.apiService.region();

  ngAfterViewInit() {
    this.checkUserDataValidity();
  }

  onButtonClose() {
    this.authService.logout();
  }

  onButtonConfirm() {
    this.router.navigate([this.translate.currentLang, 'profile', 'confirm-data']);
  }

  checkUserDataValidity() {
    if (this.user()?.validationRequired) {
      this.modalBaseComponent.openModal();
    }
  }

  toggleEditMode() {
    this.router.navigate([this.translate.currentLang, 'profile', 'change-data']);
  }

  changePassword() {
    this.router.navigate([this.translate.currentLang, 'profile', 'change-password']);
  }

  tryAgain() {
    this.userService.fetchUserData().subscribe(() => {
      this.checkUserDataValidity();
    });
  }
}
